import React from "react";
import CovidPage from "views/CovidPage/CovidPage.js";

export default () => (
  <CovidPage/>
);